<script type="text/javascript">
const url = 'https://miniapp.meyoutao.com';
  export default
  {
    url,
    getUrlKey: function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/global.vue